const CLEARED_AT_KEY = "mkc_session_cleared_at";

/** Clears persisted auth (call on logout and on global 401). */
export function clearAuthSession() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    sessionStorage.setItem(CLEARED_AT_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

/** True if logout/session clear just happened (avoid 401 handler fighting navigate("/")). */
export function isRecentSessionClear(msWindow = 2500) {
  try {
    const t = Number(sessionStorage.getItem(CLEARED_AT_KEY) || 0);
    if (!t) return false;
    return Date.now() - t < msWindow;
  } catch {
    return false;
  }
}
